module.exports = __webpack_public_path__ + "files/f3a58d26d5c5b27613729ddb49eba4b9.png";